export enum Position {
  BOTTOM = 'bottom',
  TOP = 'top',
}
